import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { Link } from "react-router"

import logoWhite from "assets/images/stacker-logo-white.png"

import { Icon8 } from "ui"
import StudioSidebar from "./components/StudioSidebar"
import AppSwitcher from "./components/AppSwitcher"
import HeaderItem from "ui/components/HeaderItem"
import WithStacks from "data/wrappers/WithStacks"

import { Section, Heading, Text } from "ui"
import {
    Hamburger,
    CloseButton,
    LogoStudio,
    Page,
    Main,
    Header,
    ContentWrapper,
    Content,
    HeaderWrapper,
} from "./ui/Layout"
class Studio extends React.Component {
    state = {}
    render() {
        window.Intercom("boot", {
            app_id: (window.location.hostname === "studio.stacker.app" ? "txwvzciy" : "bu5482h5"),
            stack_id: localStorage.getItem("stack_id"),
            //Logged out user so may not have any user related info
        })

        return (
            <Page>
                <Helmet>
                    <link rel="shortcut icon" href="/favicon.clear.png" type="image/png" />
                    <meta charSet="utf-8" />
                    <title>Stacker Studio</title>
                </Helmet>
                <Main>
                    <StudioSidebar
                        open={this.state.menuOpen}
                        closeButton={
                            <CloseButton onClick={() => this.setState({ menuOpen: false })} />
                        }
                    />
                    <ContentWrapper>
                        <Header color={this.props.color}>
                            {this.props.showAppSwitcher && (
                                <HeaderWrapper>
                                    <Heading
                                        padding="none"
                                        size="small"
                                        style={{ color: "white" }}
                                    />

                                    <AppSwitcher />
                                </HeaderWrapper>
                            )}
                            <Hamburger onClick={() => this.setState({ menuOpen: true })} />
                            <WithStacks>
                                {({ selectedStack }) => (
                                    <HeaderItem align="left" light strong>
                                        {selectedStack.name}
                                    </HeaderItem>
                                )}
                            </WithStacks>
                            <HeaderItem light align="right">
                                <Link to="/logout">Logout</Link>
                            </HeaderItem>
                        </Header>

                        <Content>{this.props.children}</Content>
                    </ContentWrapper>
                </Main>
            </Page>
        )
    }
}

Studio.propTypes = {
    children: PropTypes.node,
}

export default Studio



// WEBPACK FOOTER //
// ./src/features/studio/Studio.js